/**
 * Created by razial on 06.08.2026.
 */

const PrefabEditorAssets = function () {
    this.cache = undefined;

    this.manifest = {};
};

PrefabEditorAssets.prototype.initialize = function (callback) {
    callback = callback || function () {};

    caches.open(PrefabEditorAssets.CACHE)
        .then((cache) => {
            this.cache = cache;
            return cache.match(PrefabEditorAssets.MANIFEST);
        })
        .then((response) => (response ? response.json() : {}))
        .then((manifest) => Promise.all(Object.keys(manifest).map((bundleName) => this.applyChanges(bundleName, manifest[bundleName]))))
        .then(() => callback())
        .catch((error) => {
            cleverapps.throwAsync(`PrefabEditorAssets: load failed - ${error.message}`);
            callback();
        });
};

PrefabEditorAssets.prototype.loadBundle = function (bundleNames) {
    return Promise.all((cleverapps.toArray(bundleNames) || []).filter(Boolean).map((bundleName) => new Promise((resolve, reject) => {
        cleverapps.bundleLoader.loadBundle(bundleName, {
            onSuccess: resolve,
            onFailure: () => {
                cleverapps.bundleLoader.deleteBundle(bundleName);
                reject(new Error(`failed to load bundle "${bundleName}"`));
            }
        });
    })));
};

PrefabEditorAssets.prototype.unloadBundle = function (bundleNames) {
    (cleverapps.toArray(bundleNames) || []).filter(Boolean).forEach((bundleName) => cleverapps.bundleLoader.deleteBundle(bundleName));
};

PrefabEditorAssets.prototype.getRealBundleName = function (value) {
    const bundle = bundles[typeof value === "string" ? value : value && value.bundle];
    if (!bundle) {
        return undefined;
    }

    return bundle.injectTo ? bundle.injectTo[0] : bundle.name;
};

PrefabEditorAssets.prototype.listConfigBundles = function (config) {
    const names = {};

    const walk = (value) => {
        if (!value || typeof value !== "object") {
            return;
        }

        if (Array.isArray(value)) {
            value.forEach(walk);
            return;
        }

        const bundleName = this.getRealBundleName(value);
        if (bundleName) {
            names[bundleName] = true;
        }

        Object.values(value).forEach(walk);
    };

    walk(config);

    return Object.keys(names);
};

PrefabEditorAssets.prototype.parseDataUrl = function (url) {
    const hash = url.lastIndexOf("#");

    return {
        data: url.substring(url.indexOf(",") + 1, hash === -1 ? url.length : hash),
        fileName: hash === -1 ? undefined : url.substring(hash + 1)
    };
};

PrefabEditorAssets.prototype.exportChanges = function () {
    const files = [];

    Object.keys(this.manifest).forEach((bundleName) => {
        const config = this.manifest[bundleName];

        ["frames", "jsons", "urls"].forEach((type) => {
            Object.keys(config && config[type] || {}).forEach((key) => {
                const value = config[type][key];
                if (!value || !value.url) {
                    return;
                }

                const file = this.parseDataUrl(value.url);

                let folder = bundleName;

                if (value.regions) {
                    folder = `${bundleName}/${file.fileName.split(".")[0]}`;

                    Object.keys(value.regions).forEach((name) => {
                        const image = this.parseDataUrl(value.regions[name]);

                        files.push({ path: `${folder}/images/${image.fileName}`, data: image.data });
                    });
                }

                files.push({ path: `${folder}/${file.fileName}`, data: file.data });
            });
        });
    });

    return files;
};

PrefabEditorAssets.prototype.save = function () {
    return this.cache.put(PrefabEditorAssets.MANIFEST, new Response(JSON.stringify(this.manifest)));
};

PrefabEditorAssets.prototype.reset = function () {
    this.manifest = {};
    return this.cache.delete(PrefabEditorAssets.MANIFEST);
};

PrefabEditorAssets.prototype.applyChanges = function (bundleName, changes) {
    changes = changes || null;

    if (!changes) {
        this.manifest[bundleName] = null;
        delete bundles[bundleName];
        return;
    }

    const config = this.manifest[bundleName] = this.manifest[bundleName] || {};

    ["frames", "jsons", "urls"].forEach((type) => {
        if (changes[type]) {
            config[type] = Object.assign(config[type] || {}, changes[type]);
        }
    });

    const names = [bundleName, ...(bundles[bundleName] && bundles[bundleName].injectTo || [])];

    return Promise.all(names.map((name) => this.applyBundleChanges(name, changes)));
};

PrefabEditorAssets.prototype.applyBundleChanges = function (bundleName, changes) {
    let bundle = bundles[bundleName];
    if (!bundle) {
        bundle = bundles[bundleName] = new Bundle(bundleName, {});
    }

    const created = [];

    for (const frameId in changes.frames) {
        let frame = bundle.frames[frameId];
        if (frame) {
            delete bundle.frames[frameId];
            bundle.fromSourceResources = bundle.fromSourceResources.filter((resource) => resource !== frame);
        }

        if (changes.frames[frameId] === null) {
            // do nothing
        } else {
            frame = bundle.frames[frameId] = new SpriteFrame(bundle.name, frameId, changes.frames[frameId]);
            if (frame.fromSource) {
                bundle.fromSourceResources.push(frame);
                created.push({ type: "frames", resource: frame });
            }
        }
    }

    for (const jsonId in changes.jsons) {
        let json = bundle.jsons[jsonId];
        if (json) {
            delete bundle.jsons[jsonId];
            bundle.fromSourceResources = bundle.fromSourceResources.filter((resource) => {
                if (resource.regionSource === json) {
                    delete bundle.regions[resource.key];
                }

                return resource !== json && resource.regionSource !== json;
            });
        }

        if (changes.jsons[jsonId] === null) {
            // do nothing
        } else {
            json = bundle.jsons[jsonId] = new VirtualJson(bundle.name, jsonId, changes.jsons[jsonId]);

            if (json.fromSource) {
                bundle.fromSourceResources.push(json);
                created.push({ type: "jsons", resource: json });

                for (const name in json.regions) {
                    const region = new VirtualUrl(bundle.name, name, { fromSource: true, url: json.regions[name], regionSource: json });

                    bundle.fromSourceResources.push(region);
                    created.push({ type: "regions", resource: region });
                }
            }
        }
    }

    for (const urlId in changes.urls) {
        delete bundle.urls[urlId];

        if (changes.urls[urlId] === null) {
            // do nothing
        } else {
            bundle.urls[urlId] = new VirtualUrl(bundle.name, urlId, changes.urls[urlId]);
        }
    }

    if (!created.length || !cleverapps.bundleLoader.isLoaded(bundleName)) {
        return;
    }

    return new Promise((resolve, reject) => {
        cc.loader.load(created.map((item) => item.resource.url), { decode: true }, (status) => {
            if (status) {
                reject(new Error(`failed to load resources for "${bundleName}"`));
                return;
            }

            created.forEach(({ type, resource }) => {
                if (type === "frames") {
                    const texture = cc.textureCache.getTextureForKey(resource.url);
                    const size = texture.getContentSize();
                    resource.setFrameData({
                        texture,
                        rect: {
                            x: 0, y: 0, width: size.width, height: size.height
                        },
                        size,
                        offset: cc.p(0, 0),
                        rotated: false
                    });
                } else if (type === "jsons") {
                    resource.setJsonData(cc.loader.getRes(resource.url));
                } else if (type === "regions" && engine === "cocos2d") {
                    bundle.regions[resource.key] = BundleUtils.createSourceRegion(resource.key, cc.textureCache.getTextureForKey(resource.url));

                    if (!bundle.atlas) {
                        bundle.atlas = {
                            dispose: function () {},
                            findRegion: function (name) {
                                return bundle.regions[name];
                            }
                        };
                    }
                }
            });

            resolve();
        });
    });
};

PrefabEditorAssets.prototype.readBlob = function (blob, fileName) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(new Error(`failed to read data for "${fileName}"`));
        reader.readAsDataURL(blob);
    });
};

PrefabEditorAssets.prototype.createConfig = function (file) {
    return this.readBlob(file.blob, file.fileName).then((dataUrl) => {
        const config = { fromSource: true, url: `${dataUrl}#${file.fileName}` };

        if (!file.images) {
            return config;
        }

        return Promise.all(file.images.map((image) => this.readBlob(image.blob, image.fileName))).then((dataUrls) => {
            config.regions = {};

            file.images.forEach((image, index) => {
                config.regions[image.name] = `${dataUrls[index]}#${image.fileName}`;
            });

            return config;
        });
    });
};

PrefabEditorAssets.prototype.createAssets = function (bundleName, files) {
    return Promise.all(files.map((file) => this.createConfig(file))).then((configs) => {
        const changes = {};

        const keys = files.map((file, index) => {
            const key = file.key || file.fileName.split(".")[0];

            changes[file.type] = changes[file.type] || {};
            changes[file.type][key] = configs[index];

            return key;
        });

        return Promise.resolve(this.applyChanges(bundleName, changes))
            .then(() => this.save())
            .then(() => ({ type: files[0].type, key: keys[0] }));
    });
};

PrefabEditorAssets.prototype.removeAsset = function (bundleName, type, key) {
    return Promise.resolve(this.applyChanges(bundleName, { [type]: { [key]: null } }))
        .then(() => this.save());
};

PrefabEditorAssets.prototype.previewAsset = function (path) {
    const [, bundle, type, key] = path.split(".");

    const url = bundles[bundle] && bundles[bundle][type] && bundles[bundle][type][key];
    if (!url) {
        throw new Error(`unknown asset ${path}`);
    }

    const bundleToLoad = url.getInjectTo()[0];

    return this.loadBundle(bundleToLoad)
        .then(() => {
            const preview = PrefabEditorHelper.assetPreview(url.resolve() || url, type);

            this.unloadBundle(bundleToLoad);

            return preview;
        });
};

PrefabEditorAssets.prototype.listAssets = function () {
    const result = {};

    const filter = (bundle) => {
        if (bundle.name.match(/-debug$/)) {
            return false;
        }

        if (bundle.name.match(/_\w\w$|-\w\w$/)) { // languages
            return false;
        }

        return true;
    };

    Object.keys(bundles).forEach((name) => {
        const bundle = bundles[name];

        if (!filter(bundle)) {
            return;
        }

        result[name] = this.listBundle(bundle);
    });

    return result;
};

PrefabEditorAssets.prototype.listBundle = function (bundle) {
    return {
        frames: this.listResources(bundle, "frames"),
        jsons: this.listResources(bundle, "jsons"),
        urls: this.listResources(bundle, "urls")
    };
};

PrefabEditorAssets.prototype.listResources = function (bundle, type) {
    const result = {};

    const filter = (type, key) => {
        const excludes = [{
            type: "urls", key: "json"
        }, {
            type: "urls", key: "png"
        }, {
            type: "jsons", key: "atlas"
        }, {
            type: "jsons", key: "debug_meta_json"
        }];

        if (type === "jsons" && key.startsWith("dictionary_")) {
            return false;
        }

        return !excludes.find((excluded) => excluded.type === type && excluded.key === key);
    };

    const changes = this.manifest[bundle.name];
    const changedKeys = changes && changes[type];

    Object.keys(bundle[type]).forEach((key) => {
        if (!filter(type, key)) {
            return;
        }

        const resource = bundle[type][key];

        result[key] = {
            key,
            originalPath: resource.originalPath(),
            changed: changedKeys && changedKeys[key] ? true : undefined
        };
    });

    return result;
};

PrefabEditorAssets.CACHE = "prefabeditor";
PrefabEditorAssets.MANIFEST = "/prefabeditor/manifest.json";
